export default "__VITE_ASSET__RGOEJ4uu__"